(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["foil-product"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   Foil Style — PDP behavior
   Loaded by sections/main-product.liquid (referenced from theme.liquid or via
   {{ 'foil-product.js' | asset_url | script_tag }} at the end of the section).
   Reads all Liquid-provided values from data-* attributes + the JSON island,
   so it has zero Liquid dependencies.
   ========================================================================== */
(function () {
  function init(root) {
    if (!root || root.__foilInit) return;
    root.__foilInit = true;

    var presale = root.getAttribute('data-presale') === 'true';
    var klaviyoKey = root.getAttribute('data-klaviyo-key') || '';
    var klaviyoList = root.getAttribute('data-klaviyo-list') || '';
    var productTitle = root.getAttribute('data-product-title') || '';

    var variants = [];
    try {
      var island = root.querySelector('#foilVariantData');
      if (island) variants = JSON.parse(island.textContent || '[]');
    } catch (e) { variants = []; }

    var selected = {}; // optionIndex -> value

    /* ---------- gallery ---------- */
    var thumbs = root.querySelector('#foilThumbs');
    var mainImg = root.querySelector('#foilMainImg');
    if (thumbs && mainImg) {
      thumbs.addEventListener('click', function (e) {
        var btn = e.target.closest('.foil-thumb');
        if (!btn) return;
        thumbs.querySelectorAll('.foil-thumb').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        mainImg.src = btn.getAttribute('data-src');
      });
    }

    /* ---------- swatches (color) ---------- */
    var swatches = root.querySelector('#foilSwatches');
    var colorVal = root.querySelector('#foilColorVal');
    if (swatches) {
      var ci = parseInt(swatches.getAttribute('data-option-index'), 10);
      var activeSw = swatches.querySelector('.foil-swatch.active');
      if (activeSw) selected[ci] = activeSw.getAttribute('data-name');
      swatches.addEventListener('click', function (e) {
        var s = e.target.closest('.foil-swatch');
        if (!s) return;
        swatches.querySelectorAll('.foil-swatch').forEach(function (x) { x.classList.remove('active'); });
        s.classList.add('active');
        if (colorVal) colorVal.textContent = s.getAttribute('data-name');
        selected[ci] = s.getAttribute('data-name');
        recompute();
      });
    }

    /* ---------- sizes ---------- */
    var sizes = root.querySelector('#foilSizes');
    if (sizes) {
      var si = parseInt(sizes.getAttribute('data-option-index'), 10);
      var activeSz = sizes.querySelector('.foil-size.active');
      if (activeSz) selected[si] = activeSz.getAttribute('data-value');
      sizes.addEventListener('click', function (e) {
        var el = e.target.closest('.foil-size');
        if (!el || el.classList.contains('soldout')) return;
        sizes.querySelectorAll('.foil-size').forEach(function (x) { x.classList.remove('active'); });
        el.classList.add('active');
        selected[si] = el.getAttribute('data-value');
        recompute();
      });
    }

    /* ---------- variant matching (live mode) ---------- */
    var variantInput = root.querySelector('#foilVariantId');
    var priceEl = root.querySelector('#foilPrice');
    var addBtn = root.querySelector('#foilAddBtn');

    function findVariant() {
      var keys = Object.keys(selected);
      return variants.find(function (v) {
        return keys.every(function (k) {
          var idx = parseInt(k, 10); // option position 1..3
          return v['option' + idx] === selected[k];
        });
      });
    }
    function money(cents) {
      try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; }
    }
    function recompute() {
      var v = findVariant();
      if (variantInput && v) variantInput.value = v.id;
      if (priceEl && v) priceEl.firstChild && (priceEl.childNodes[0].nodeValue = money(v.price) + ' ');
      if (addBtn) {
        if (v && v.available) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
        else if (v) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
      }
    }

    /* ---------- qty ---------- */
    var qtyInput = root.querySelector('#foilQty');
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var d = parseInt(b.getAttribute('data-qty'), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
      });
    });

    /* ---------- accordion ---------- */
    var accordion = root.querySelector('#foilAccordion');
    if (accordion) {
      accordion.querySelectorAll('.foil-acc-item.open .foil-acc-body').forEach(function (b) {
        b.style.maxHeight = b.scrollHeight + 'px';
      });
      accordion.addEventListener('click', function (e) {
        var h = e.target.closest('.foil-acc-head');
        if (!h) return;
        var item = h.parentElement;
        var body = item.querySelector('.foil-acc-body');
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    }

    /* ---------- notify modal + Klaviyo ---------- */
    var modal = root.querySelector('#foilModal');
    var notifyBtn = root.querySelector('#foilNotifyBtn');
    var modalX = root.querySelector('#foilModalX');
    var form = root.querySelector('#foilNotifyForm');
    var statusEl = root.querySelector('#foilNotifyStatus');
    var emailEl = root.querySelector('#foilNotifyEmail');

    function openModal() { if (modal) { modal.classList.add('show'); modal.setAttribute('aria-hidden', 'false'); setTimeout(function () { emailEl && emailEl.focus(); }, 60); } }
    function closeModal() { if (modal) { modal.classList.remove('show'); modal.setAttribute('aria-hidden', 'true'); } }

    if (notifyBtn) notifyBtn.addEventListener('click', openModal);
    if (modalX) modalX.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailEl.value || '').trim();
        if (!email) return;
        setStatus('Submitting…', '');

        if (!klaviyoKey || !klaviyoList) {
          // No Klaviyo configured yet — succeed gracefully so the UX still works in staging.
          setStatus("You're on the list. (Connect Klaviyo to capture live.)", 'ok');
          form.reset();
          return;
        }

        subscribeKlaviyo(email)
          .then(function () { setStatus("You're on the list. We'll be in touch — no spam.", 'ok'); form.reset(); })
          .catch(function () { setStatus('Something went wrong. Please try again.', 'err'); });
      });
    }

    function setStatus(msg, cls) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'foil-modal-status' + (cls ? ' ' + cls : '');
    }

    // Klaviyo Client API — public, browser-safe (subscribe to list).
    // Docs: POST https://a.klaviyo.com/client/subscriptions/?company_id=PUBLIC_KEY
    function subscribeKlaviyo(email) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { 'Interested Product': productTitle, 'Source': 'PDP Notify Me' }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: klaviyoList } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error('Klaviyo ' + r.status);
        return true;
      });
    }
  }

  function boot() {
    document.querySelectorAll('.foil-pdp-wrap').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', boot);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
